import { useContext } from 'react'
import { ParagraphSmall } from 'baseui/typography'
import { StepperContext } from '../contexts/StepperContext'
import { useTranslation } from 'react-i18next'

export const Stepper = () => {
  const stepperContext = useContext(StepperContext)
  const { t } = useTranslation()


  // Cuando hay más de 5 pasos, se cambian los estilos para que la interfaz quede mejor
  const hasMoreThanFiveSteps = stepperContext?.steps.length > 5
  
  // En caso de que haya más de 5 pasos, se ocultan el primero y el último
  const shouldShowStep = (stepIndex: number) => {
    if (!hasMoreThanFiveSteps) return true;
    
    const totalSteps = stepperContext?.steps.length || 0;
    if (stepIndex === 0 || stepIndex === totalSteps - 1) {
      return false;
    }

    return true;
  };
  
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        flexWrap: 'wrap',
        gap: '1rem',
        marginBottom: '1rem'
      }}
    >
      {stepperContext?.steps.map((step: string, index: number) => {
        if (!shouldShowStep(index)) return null;
        
        return (
        <span
          style={{
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: hasMoreThanFiveSteps ? '0.5rem' : '0.875rem'
          }}
          key={step}
        >
          <ParagraphSmall
            overrides={{
              Block: {
                style: {
                  fontWeight:
                    stepperContext?.currentStep === step ? 'bold' : 'normal',
                  ...(window.outerWidth < 500 &&
                  stepperContext?.currentStep !== step
                    ? { display: 'none' }
                    : {})
                }
              }
            }}
          >
            {t(step)}
          </ParagraphSmall>
          {window.outerWidth > 500 && index < stepperContext?.steps.length - 1 && shouldShowStep(index + 1) && (
            <ParagraphSmall>
              {'>'}
            </ParagraphSmall>
          )}
        </span>
        );
      })}
    </div>
  )
}
